module.exports = __webpack_public_path__ + "static/media/4590.ddbb0412.jpg";